import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend, LineChart, Line } from "recharts";
import { formatBRL } from "@/lib/constants";

const PERIODS = [[1, "Mês"], [3, "3 meses"], [6, "6 meses"], [12, "Ano"]];

export const DashboardCharts = () => {
  const [n, setN] = useState(6);
  const [fin, setFin] = useState([]);
  const [bud, setBud] = useState([]);
  useEffect(() => {
    api.get("/reports/monthly", { params: { n } }).then(({ data }) => setFin(data)).catch(() => {});
    api.get("/reports/budgets-monthly", { params: { n } }).then(({ data }) => setBud(data)).catch(() => {});
  }, [n]);
  const totRec = fin.reduce((s, m) => s + (m.received || 0), 0);
  const totPend = fin.reduce((s, m) => s + (m.pending || 0), 0);
  const totApr = bud.reduce((s, m) => s + (m.approved || 0), 0);
  const totPen = bud.reduce((s, m) => s + (m.pending || 0), 0);
  const totSvc = bud.reduce((s, m) => s + (m.services || 0), 0);

  return (
    <div className="space-y-2" data-testid="dashboard-charts">
      <div className="flex items-center justify-between gap-2">
        <p className="font-display font-bold text-xs uppercase tracking-wide text-muted-foreground">Desempenho</p>
        <div className="flex gap-1">{PERIODS.map(([v, l]) => <button key={v} onClick={() => setN(v)} data-testid={`chart-period-${v}`} className={`h-8 px-3 rounded-full text-xs font-medium border transition-colors ${n === v ? "bg-primary text-primary-foreground border-primary" : "bg-card border-border"}`}>{l}</button>)}</div>
      </div>
      <div className="grid md:grid-cols-2 gap-2">
        <Card className="p-3" data-testid="chart-revenue">
          <div className="flex items-baseline justify-between mb-1"><p className="text-sm font-semibold">Faturamento mensal</p><p className="text-xs text-muted-foreground">Recebido <b className="text-secondary">{formatBRL(totRec)}</b> • A receber <b className="text-amber-600">{formatBRL(totPend)}</b></p></div>
          <div className="h-44">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={fin} margin={{ top: 4, right: 4, left: -18, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="hsl(var(--border))" />
                <XAxis dataKey="month" tick={{ fontSize: 11 }} /><YAxis tick={{ fontSize: 10 }} tickFormatter={(v) => (v >= 1000 ? `${Math.round(v / 1000)}k` : v)} />
                <Tooltip formatter={(v) => formatBRL(v)} contentStyle={{ borderRadius: 12, fontSize: 12 }} />
                <Legend wrapperStyle={{ fontSize: 11 }} />
                <Bar dataKey="received" name="Recebido" fill="hsl(var(--secondary))" radius={[6, 6, 0, 0]} />
                <Bar dataKey="pending" name="A receber" fill="#f59e0b" radius={[6, 6, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Card>
        <Card className="p-3" data-testid="chart-budgets">
          <div className="flex items-baseline justify-between mb-1"><p className="text-sm font-semibold">Orçamentos e serviços</p><p className="text-xs text-muted-foreground"><b className="text-secondary">{totApr}</b> aprovados • <b className="text-amber-600">{totPen}</b> pendentes • <b>{totSvc}</b> serviços</p></div>
          <div className="h-44">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={bud} margin={{ top: 4, right: 8, left: -22, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="hsl(var(--border))" />
                <XAxis dataKey="month" tick={{ fontSize: 11 }} /><YAxis tick={{ fontSize: 10 }} allowDecimals={false} />
                <Tooltip contentStyle={{ borderRadius: 12, fontSize: 12 }} />
                <Legend wrapperStyle={{ fontSize: 11 }} />
                <Line type="monotone" dataKey="approved" name="Aprovados" stroke="hsl(var(--secondary))" strokeWidth={2.5} dot={{ r: 3 }} />
                <Line type="monotone" dataKey="pending" name="Pendentes" stroke="#f59e0b" strokeWidth={2.5} dot={{ r: 3 }} />
                <Line type="monotone" dataKey="services" name="Serviços" stroke="hsl(var(--primary))" strokeWidth={2.5} dot={{ r: 3 }} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </Card>
      </div>
    </div>
  );
};
